import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FutureTermPage } from './future-term.page';

const routes: Routes = [
  {
    path: '',
    component: FutureTermPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FutureTermPageRoutingModule {}
